export default __webpack_public_path__ + "assets/graficas.jpg";